// @flow
import _ from 'lodash'

export default function calculatePriceConstraints(
  providerConstraints: Object,
  providers: Array<string>
): {| minimum: Array<number>, maximum: Array<number> |} {
  let mins = []
  let maxs = []
  _.each(providerConstraints, (values, provider) => {
    if (_.includes(providers, provider)) {
      mins.push(values['minimum'])
      maxs.push(values['maximum'])
    }
  })
  return { minimum: mins, maximum: maxs }
}
